// Libs
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { browserHistory } from "react-router";

// Components
import Divider from "../component/Divider";
import SocialButton from "../component/SocialButton";
import SignUpFormContainer from "./signup/SignUpFormContainer";

// Images
import iconNumberOne from "../images/icon-number-one.svg";
import iconSpocketLogo from "../images/icon-spocket-logo.svg";
import iconFlags from "../images/flags.svg";

// Libs
import {
  Title,
  Header,
  Subtitle,
  FakeModal,
  SignInButton,
  PageContainer,
  BackgroundImage,
  SubtitleContainer,
  SocialButtonContainer
} from "./RegistrationStyle";

const Registration = () => {
  const [spocketUtm, setSpocketUtm] = useState("");

  //  If there is spocket_utm cookie, we are setting it into the spocketUtm local state
  useEffect(() => {
    Cookies.get("spocket_utm") && setSpocketUtm(Cookies.get("spocket_utm"));
  });

  /**
   * Category selector field will only show for affiliates with the IDs of amerb5044 zishanmanji6655
   * Refer to #5159 for more details on this logic.
   * https://github.com/spocket-co/spocket/issues/5159
   */
  const showCategorySelectForAffiliates = () => {
    if (
      spocketUtm.indexOf("amerb5044") === -1 &&
      spocketUtm.indexOf("zishanmanji6655") === -1
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div>
      <PageContainer categorySelector={showCategorySelectForAffiliates()}>
        <FakeModal>
          <Header>
            <img src={iconSpocketLogo} alt="Spocket Logo" />
            <Title>Sign up</Title>
            <SubtitleContainer>
              <Subtitle>
                <div>
                  <img src={iconNumberOne} alt="Number one badge" /> The{" "}
                  <span>world’s #1</span> fast
                </div>
                <div>
                  dropshipping collection
                  <img src={iconFlags} alt="US and EU flags" />
                </div>
              </Subtitle>
            </SubtitleContainer>
          </Header>
          <SignUpFormContainer />
          <Divider>or</Divider>
          <SocialButtonContainer>
            <SocialButton type="google">Sign up with Google</SocialButton>
            <SocialButton type="facebook">Sign up with Facebook</SocialButton>
          </SocialButtonContainer>
        </FakeModal>
        <SignInButton onClick={() => browserHistory.push("/login")}>
          Already have an account? <strong>Sign in</strong>
        </SignInButton>
        <BackgroundImage />
      </PageContainer>
    </div>
  );
};

export default Registration;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/Registration.js